import React, { FC, useMemo } from 'react';

import * as Sentry from '@sentry/react';

import api from '~/Api';
import analytics from '~/services/analytics';

import {
  GrammarCheckerConfig,
  GrammarCheckerProvider,
  GrammarCheckResult,
} from './src';

const GrammarCheckerWrapper: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const config = useMemo<GrammarCheckerConfig>(
    () => ({
      checkText: (text: string): Promise<GrammarCheckResult> =>
        api.checkGrammar(text),
      analytics: {
        trackEvent: (event: string, data?: Record<string, any>): void =>
          analytics.trackEvent(event as any, data),
      },
      errorLogger: {
        captureMessage: (msg, level) =>
          Sentry.captureMessage(msg, level as Sentry.SeverityLevel),
        logError: (err) => Sentry.captureException(err),
      },
      debounceMs: 300,
    }),
    [],
  );

  return (
    <GrammarCheckerProvider config={config}>{children}</GrammarCheckerProvider>
  );
};

export default GrammarCheckerWrapper;
